import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { checkPermissions } from '../../utils/roles/permissionUtils';

interface ProtectedRouteProps {
  code: string;
  actionTypes?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ code, actionTypes = ['Read', 'Write', 'Edit', 'Delete'] }: ProtectedRouteProps) => (checkPermissions(code, actionTypes, true) ? <Outlet /> : <Navigate to="/not-authorized" />);

ProtectedRoute.defaultProps = {
  actionTypes: ['Read', 'Write', 'Edit', 'Delete'],
};

export default ProtectedRoute;
